<ng-template #arrows>
    <ion-icon *ngIf="sortData.direction === '-'" slot="end" name="chevron-up-outline"></ion-icon>
    <ion-icon *ngIf="sortData.direction === '+'" slot="end" name="chevron-down-outline"></ion-icon>
</ng-template>

<!-- wide version -->
<ion-item *ngIf="wide" lines="full">
    <ion-label class="preLineWhitespace" position="stacked"
               innerHTML="{{'search.simple_sort' | translate}}"></ion-label>
    <span>
        <ion-button size="small"
                    (click)="setOrder('add')" [fill]="isSortOrder('add') ? 'solid':'outline'"
                    innerHTML="{{'search.simple_sort_add_short' | translate}}">
        </ion-button>
        <ion-button size="small"
                    (click)="setOrder('edit')" [fill]="isSortOrder('edit') ? 'solid':'outline'"
                    innerHTML="{{'search.simple_sort_edit_short' | translate}}">
        </ion-button>
        <ion-button size="small"
                    (click)="setOrder('invnr')" [fill]="isSortOrder('invnr') ? 'solid':'outline'"
                    innerHTML="{{'search.simple_sort_invnr_short' | translate}}">
        </ion-button>
        <ion-button size="small"
                    (click)="setOrder('category')" [fill]="isSortOrder('category') ? 'solid':'outline'"
                    innerHTML="{{'search.simple_sort_category_short' | translate}}">
        </ion-button>
        <ion-button size="small" fill="outline" (click)="changeDirection()">
            <ng-container *ngTemplateOutlet="arrows"></ng-container>
        </ion-button>
    </span>
</ion-item>

<!-- high version -->

<ion-item *ngIf="!wide">
    <ion-item lines="none" class="compact">
        <ion-label class="preLineWhitespace" innerHTML="{{'search.simple_sort' | translate}}"></ion-label>
    </ion-item>
    <ion-list>

        <ion-item button class="subitem" lines="inset" (click)="setOrder('add')" detail="false">
            <ion-label>{{'search.simple_sort_add' | translate}}</ion-label>
            <ng-container *ngIf="isSortOrder('add')">
                <ng-container *ngTemplateOutlet="arrows"></ng-container>
            </ng-container>
        </ion-item>
        <ion-item button class="subitem" lines="inset" (click)="setOrder('edit')" detail="false">
            <ion-label>{{'search.simple_sort_edit' | translate}}</ion-label>
            <ng-container *ngIf="isSortOrder('edit')">
                <ng-container *ngTemplateOutlet="arrows"></ng-container>
            </ng-container>
        </ion-item>
        <ion-item button class="subitem" lines="inset" (click)="setOrder('invnr')" detail="false">
            <ion-label>{{'search.simple_sort_invnr' | translate}}</ion-label>
            <ng-container *ngIf="isSortOrder('invnr')">
                <ng-container *ngTemplateOutlet="arrows"></ng-container>
            </ng-container>
        </ion-item>
        <ion-item button class="subitem" lines="none" (click)="setOrder('category')" detail="false">
            <ion-label>{{'search.simple_sort_category' | translate}}</ion-label>
            <ng-container *ngIf="isSortOrder('category')">
                <ng-container *ngTemplateOutlet="arrows"></ng-container>
            </ng-container>
        </ion-item>
    </ion-list>
</ion-item>
